<template>
  <v-btn tile large class="primary" @click="calculatePaymentPlan" :loading="loading" :disabled="disabled">
    {{ $t('cppb-text-1') }}
    <v-dialog v-model="showDialog"
              :fullscreen="dialogSettings.fullscreen"
              :scrollable="dialogSettings.scrollable"
              :hide-overlay="dialogSettings.hideoverlay"
              :transition="dialogSettings.transition"
              :width="dialogSettings.width"
              :max-width="dialogSettings.maxwidth"
              content-class="full-screen-dialog">
      <v-card class="dialog-card">
        <v-toolbar flat light color="white" v-if="dialogSettings.fullscreen">
          <v-toolbar-title>{{ $t('cppb-text-2') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-container class="pa-0 grow" fluid>
          <v-row no-gutters>
            <v-card-text>
              <v-col cols="12" class="text-right" v-if="!dialogSettings.fullscreen">
                <v-btn color="color-grey" depressed right text small @click="closeDialog">
                  <v-icon class="mr-3">fa-times</v-icon>
                  <span>{{ $t('close') }}</span>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col :class="{ 'text-center': $vuetify.breakpoint.mdAndUp }">
                    <h3 class="mt-0 text-h3" v-if="!dialogSettings.fullscreen">{{ $t('cppb-text-2') }}</h3>
                    <span v-if="installments.length > 0">
                      {{ $t('cppb-text-3') }}
                    </span>
                    <div><b>{{ $t('cppb-text-4') }}</b></div>
                    <div><b>{{ $t('paymentPlanInterestNotion') }}</b></div>
                  </v-col>
                </v-row>
                <v-row :class="{'justify-center': $vuetify.breakpoint.mdAndUp }" v-if="installments.length > 0">
                  <div class="pa-3">
                    <p class="ok-title">{{ $t('cppb-text-5') }}</p>
                    <span class="ok-subtitle font-weight-bold mr-3">{{ installments[0].amount | currency }}</span>
                    <span class="ok-subtitle">{{ installments[0].dueDate | formatDate }}</span>
                  </div>
                  <div class="pa-3">
                    <p class="ok-title">{{ $t('cppb-text-6') }}</p>
                    <p class="ok-subtitle">{{ installments.length }} {{ $t('kpl') }}</p>
                  </div>
                  <div class="pa-3">
                    <p class="ok-title">{{ $t('cppb-text-7') }}</p>
                    <p class="ok-subtitle">{{ calculatedPaymentPlan.paymentPlan.price | currency }}</p>
                  </div>
                </v-row>
              </v-col>
            </v-card-text>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-divider></v-divider>
              <v-expansion-panels flat>
                <v-expansion-panel v-if="installments.length > 0">
                  <v-expansion-panel-header class="pp-expansion-header py-6 text-center" expand-icon="fas fa-chevron-circle-down">
                    <span class="ok-title mb-0">{{ $t('cppb-text-10') }}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table :headers="headers"
                                  :items="installments"
                                  hide-default-footer
                                  :items-per-page="-1"
                                  :mobile-breakpoint="0">
                      <template #item.sequence="{ item }">
                        <v-badge color="white">
                          <span slot="badge" class="black--text">{{ item.sequence }}</span>
                        </v-badge>
                      </template>
                      <template #item.duedate="{ item }">
                        {{ item.dueDate | formatDate }}
                      </template>
                      <template #item.amount="{ item }">
                        {{ item.amount | currency }}
                      </template>
                      <template #item.capital="{ item }">
                        {{ item.capital | currency }}
                      </template>
                      <template #item.costs="{ item }">
                        {{ item.costs | currency }}
                      </template>
                      <template #item.interest="{ item }">
                        {{ item.interest | currency }}
                      </template>
                    </v-data-table>
                    <v-row no-gutters justify="center">
                      <div class="pa-3">
                        <span class="ok-title small mr-2">{{ $t('capital') }}:</span>
                        <span class="text-caption">{{ calculatedPaymentPlan.totalCapital | currency }}</span>
                      </div>
                      <div class="pa-3">
                        <span class="ok-title small mr-2">{{ $t('interests') }}:</span>
                        <span class="text-caption">{{ calculatedPaymentPlan.totalInterest | currency }}</span>
                      </div>
                      <div class="pa-3">
                        <span class="ok-title small mr-2">{{ $t('cppb-text-9') }}:</span>
                        <span class="text-caption">{{ calculatedPaymentPlan.totalCost | currency }}</span>
                      </div>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-card-text>
              <v-row justify="center" align="center" v-if="installments.length > 0 && !disablePhoneNumberAdd">
                <v-col cols="12" sm="8">
                  <p class="text-h8 text-center mt-0">
                    {{ $t('cppb-text-11') }}
                  </p>
                </v-col>
                <v-col cols="12" sm="8">
                  <span class="text-subtitle-1 mb-0" :class="{ 'mr-2': $vuetify.breakpoint.mdAndUp }" v-if="phoneNumbers.length > 0">{{ $t('cppb-text-12') }}</span>
                  <br v-if="$vuetify.breakpoint.smAndDown" />
                  <span class="text-subtitle-1 mb-0 font-weight-bold" :class="{ 'mr-6': $vuetify.breakpoint.mdAndUp }" v-if="phoneNumbers.length > 0">{{ phoneNumbers[0].number }}</span>
                  <br v-if="$vuetify.breakpoint.smAndDown" />
                  <v-btn text class="color-new-title-grey--text px-0" @click="showPhoneForm = true" v-show="!showPhoneForm">
                    <v-icon class="mr-2">far fa-edit</v-icon>
                    {{ phoneNumbers.length > 0 ? $t('cppb-text-14') : $t('cppb-text-13') }}
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="8" v-show="showPhoneForm">
                  <v-form @submit.prevent="addPhoneNumber()">
                    <v-row no-gutters align="center">
                      <v-col cols="8" sm="5" class="pr-3">
                        <v-text-field :label="$t('phone')"
                                      v-model="phoneNumber"
                                      @blur="$v.phoneNumber.$touch()"
                                      @change="$v.phoneNumber.$touch()"
                                      prefix="+358"
                                      class="long-prefix"
                                      placeholder=" "
                                      persistent-hint
                                      :error-messages="phoneNumberError">
                        </v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-btn small tile color="success" @click="addPhoneNumber()" :disabled="$v.phoneNumber.$error || !$v.phoneNumber.$dirty || phoneNumber.length === 0">{{ $t('add') }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-row>
        </v-container>
        <v-card-actions class="justify-center pa-4">
          <div class="pa-3">
            <v-btn tile dark class="primary" v-if="installments.length > 0" @click="createPaymentPlan" :loading="creating">{{ $t('cppb-text-8') }}</v-btn>
          </div>
          <div class="pa-3">
            <v-btn tile outlined dark color="color-new-link-blue" @click="closeDialog">{{ $t('cancel') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { numeric, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    props: ['debts', 'amount', 'desiredDueDate'],
    data: function () {
      return {
        loading: false,
        creating: false,
        showDialog: false,
        calculatedPaymentPlan: null,
        phoneNumber: '',
        showPhoneForm: false
      }
    },
    computed: {
      debtor () {
        return this.$store.getters.debtor
      },
      phoneNumbers () {
        return this.debtor.contactInformation.phones
      },
      dialogSettings () {
        return {
          fullscreen: this.$vuetify.breakpoint.smAndDown,
          scrollable: false, // this.$vuetify.breakpoint.smAndDown,
          hideoverlay: this.$vuetify.breakpoint.smAndDown,
          transition: this.$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition',
          width: this.$vuetify.breakpoint.smAndDown ? 'auto' : '1000px',
          maxwidth: this.$vuetify.breakpoint.smAndDown ? 'none' : '90%'
        }
      },
      paymentPlanRequest () {
        var debtNrs = this.debts.map(function (s) { return s.nr })
        return {
          debtNrs: debtNrs,
          type: 0,
          amount: this.amount,
          date: parseInt(this.desiredDueDate, 10)
        }
      },
      installments () {
        return this.calculatedPaymentPlan !== null ? this.calculatedPaymentPlan.paymentPlan.installments : []
      },
      disabled () {
        if (this.amount === null || this.debts.length === 0) {
          return true
        }

        var minAmount = 0
        var maxAmount = 0

        if (this.installments.length && this.installments[0].amount > this.amount) {
          minAmount = this.installments[0].amount
        }

        this.debts.forEach((debt) => {
          maxAmount += debt.debtSummary.left
        })

        if (this.amount >= minAmount && this.amount <= maxAmount) {
          return false
        } else {
          return true
        }
      },
      headers () {
        let desktopHeaders = [
          { text: this.$t('installment'), value: 'sequence', sortable: false, class: 'pp-table-header' },
          { text: this.$t('dueDate'), value: 'duedate', sortable: false, class: 'pp-table-header' },
          { text: this.$t('installmentSequence'), value: 'amount', sortable: false, class: 'pp-table-header' },
          { text: this.$t('capital'), value: 'capital', sortable: false, class: 'pp-table-header' },
          { text: this.$t('costs'), value: 'costs', sortable: false, class: 'pp-table-header' },
          { text: this.$t('interests'), value: 'interest', sortable: false, class: 'pp-table-header' }
        ]

        let mobileHeaders = [
          { text: this.$t('installment'), value: 'sequence', sortable: false, class: 'pp-table-header' },
          { text: this.$t('dueDate'), value: 'duedate', sortable: false, class: 'pp-table-header' },
          { text: this.$t('installmentSequence'), value: 'amount', sortable: false, class: 'pp-table-header' }
        ]

        return this.$vuetify.breakpoint.smAndDown ? mobileHeaders : desktopHeaders
      },
      disablePhoneNumberAdd () {
        return this.$store.getters.hidePersonalInfo
      },
      phoneNumberError () {
        const errors = []
        if (!this.$v.phoneNumber.$dirty || this.phoneNumber === '') return errors
        !this.$v.phoneNumber.numeric && errors.push(this.$t('validation.phone.numeric'))
        !this.$v.phoneNumber.minLength && errors.push(this.$t('validation.phone.length'))
        !this.$v.phoneNumber.maxLength && errors.push(this.$t('validation.phone.length'))
        return errors
      }
    },
    methods: {
      closeDialog () {
        this.loading = false
        this.creating = false
        this.showDialog = false
        this.calculatedPaymentPlan = null
        this.phoneNumber = ''
        this.showPhoneForm = false
      },
      calculatePaymentPlan: function (event) {
        this.loading = true
        this.calculatedPaymentPlan = null

        let payload = {
          DebtNrs: this.paymentPlanRequest.debtNrs,
          Type: this.paymentPlanRequest.type,
          Amount: this.paymentPlanRequest.amount,
          DateSelection: this.paymentPlanRequest.date,
          Create: false
        }

        apiResource.post('api/paymentPlan/calculate', payload).then((response) => {
          this.loading = false
          if (response.data.status === 0) {
            this.calculatedPaymentPlan = response.data.responseObject

            if (this.installments.length && this.installments[0].amount <= this.paymentPlanRequest.amount) {
              this.showDialog = true
              if (payload.DebtNrs.length > 1) {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create CPP Start")
              } else {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create PP Start")
              }
            } else {
              this.$emit('minAmount', this.installments.length ? this.installments[0].amount : null)
            }
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'Virhe maksusuunnitelman luonnissa.' })
          }
        }).catch((errorResponse) => {
          console.log(errorResponse)
          this.$store.commit('setMessage', { type: 'error', text: 'Virhe.' })
          this.loading = false
          this.calculatedPaymentPlan = null
        })
      },
      addPhoneNumber () {
        let payload = { ContactType: 'phone', Text: this.phoneNumber, Allow: true }
        this.$store.dispatch('addDebtorContact', payload)
        this.phoneNumber = ''
      },
      createPaymentPlan: function (event) {
        this.creating = true

        let payload = {
          DebtNrs: this.paymentPlanRequest.debtNrs,
          Type: this.paymentPlanRequest.type,
          Amount: this.paymentPlanRequest.amount,
          DateSelection: this.paymentPlanRequest.date,
          Create: true
        }

        apiResource.post('api/paymentPlan/create', payload).then((response) => {
          this.creating = false
          if (response.data.status === 0) {
            if (response.data.responseObject === true) {
              let p = {
                type: 'paymentplan'
              }
              if (payload.DebtNrs.length > 1) {
                p.redirectToLatestPaymentPlan = true
              }
              this.$store.dispatch('initialize', p)
              this.$store.commit('setMessage', { type: 'success', text: this.$t('paymentPlanResults.0') })
              this.showDialog = false

              if (payload.DebtNrs.length > 1) {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create CPP Completed", this.paymentPlanRequest.amount)
              } else {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create PP Completed", this.paymentPlanRequest.amount)
              }
            } else {
              this.$store.commit('setMessage', { type: 'error', text: 'Virhe maksusuunnitelman luonnissa.' })

              if (payload.DebtNrs.length > 1) {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create CPP Failed")
              } else {
                this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create PP Failed")
              }
            }
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'Virhe maksusuunnitelman luonnissa.' })

            if (payload.DebtNrs.length > 1) {
              this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create CPP Failed")
            } else {
              this.$matomo && this.$matomo.trackEvent("Management", "Create Payment plan", "Create PP Failed")
            }
          }
        }).catch((errorResponse) => {
          console.log(errorResponse)
          this.$store.commit('setMessage', { type: 'error', text: 'Virhe.' })
          this.creating = false
        })
      }
    },
    watch: {
      showDialog (val, oldVal) {
        if (!val && oldVal) {
          this.loading = false
          this.creating = false
          this.calculatedPaymentPlan = null
        }
      }
    },
    validations: {
      phoneNumber: {
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(12)
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "cppb-text-1": "Jatka vahvistamaan",
  "cppb-text-2": "Vahvista maksusuunnitelma",
  "cppb-text-3": "Alla näet valitsemasi maksuohjelman tiedot. Muistathan, että maksusuunnitelman tekeminen on sitovaa.",
  "cppb-text-4": "Hyväksymisen jälkeen voit tarkistaa maksusuunnitelman ajantasaiset tiedot Oma B2 Impact -palvelussa.",
  "cppb-text-5": "Ensimmäinen erä",
  "cppb-text-6": "Eriä",
  "cppb-text-7": "Maksusuunnitelman hinta",
  "cppb-text-8": "Hyväksy & vahvista",
  "cppb-text-9": "Kulut yhteensä",
  "cppb-text-10": "Näytä suunnitelman tarkemmat tiedot",
  "cppb-text-11": "Muistutamme eräpäivästä tekstiviestillä.",
  "cppb-text-12": "Toimitamme viestin numeroon",
  "cppb-text-13": "Lisää puhelinnumero",
  "cppb-text-14": "Vaihda puhelinnumero"
  },
  "se": {
  "cppb-text-1": "Fortsätt",
  "cppb-text-2": "Bekräfta betalningsplanen",
  "cppb-text-3": "Nedan ser du information om den betalningsplan du har valt. Kom ihåg att det är bindande att göra en betalningsplan.",
  "cppb-text-4": "Efter godkännandet kan du kontrollera de aktuella detaljerna för din betalningsplan i tjänsten Oma B2 Impact.",
  "cppb-text-5": "Första raten",
  "cppb-text-6": "Rater",
  "cppb-text-7": "Kostnad för betalningsplanen",
  "cppb-text-8": "Godkänn & bekräfta",
  "cppb-text-9": "Kostnader totalt",
  "cppb-text-10": "Visa detaljerad information",
  "cppb-text-11": "Vi skickar ett SMS på förfallodagen till ditt telefonnummer",
  "cppb-text-12": "Vi skickar ett SMS på förfallodagen till ditt telefonnummer, var vänlig och sätt till ditt telefonnummer:",
  "cppb-text-13": "Sätt till telefonnummer",
  "cppb-text-14": "Vaihda puhelinnumero"
  },
  "en": {
  "cppb-text-1": "Continue",
  "cppb-text-2": "Confirm the payment plan",
  "cppb-text-3": "Below you can see the details of your selected payment plan. Please note that creating a payment plan is binding.",
  "cppb-text-4": "After approval, you can check the up-to-date details of your payment plan in the Oma B2 Impact service.",
  "cppb-text-5": "First installment",
  "cppb-text-6": "Installments",
  "cppb-text-7": "Cost of the payment plan",
  "cppb-text-8": "Confirm",
  "cppb-text-9": "Total cost",
  "cppb-text-10": "Show detailed information",
  "cppb-text-11": "We will remind you about payment",
  "cppb-text-12": "We will send a SMS-message to your phone when next payment is due. Message will be sent to",
  "cppb-text-13": "Add phone number",
  "cppb-text-14": "Change phone number"
  }
  }
</i18n>

<style>
  .theme--light .v-table {
    background-color: inherit;
  }
</style>
